import { render, staticRenderFns } from "./DiscoveryView.vue?vue&type=template&id=0327fbfb&scoped=true"
import script from "./DiscoveryView.vue?vue&type=script&lang=js"
export * from "./DiscoveryView.vue?vue&type=script&lang=js"
import style0 from "./DiscoveryView.vue?vue&type=style&index=0&id=0327fbfb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0327fbfb",
  null
  
)

export default component.exports